import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { LoadingDialogUtilService } from 'v2/modules/shared/services/util/loading-dialog-util.service';
import { trackById } from 'v2/modules/shared/util/track-by.util';

@Component({
  selector: 'lum-sales-order-invoice-ids-cell-renderer',
  templateUrl: './sales-order-invoice-ids-cell-renderer.component.html',
  styleUrls: ['./sales-order-invoice-ids-cell-renderer.component.scss'],
})
export class SalesOrderInvoiceIdsCellRendererComponent
  implements ICellRendererAngularComp
{
  private cellRendererParams :ICellRendererParams;
  invoices :{
    id :number;
  }[] = [];
  trackById = trackById;

  constructor(private loadingDialogService :LoadingDialogUtilService) {}

  agInit(params :ICellRendererParams) :void {
    this.cellRendererParams = params;
    this.invoices = params.value || [];
  }

  refresh(params :ICellRendererParams<any, any, any>) :boolean {
    // Return true to indicate that the cell content has been updated
    return true;
  }

  openInvoiceInNewTab(invoiceId :number | undefined | null) :void {
    if (!invoiceId) {
      this.loadingDialogService.show('Invoice ID not found.');

      return;
    }
    const url = `/sales/view/invoices?invoiceId=${invoiceId}`;
    window.open(url, '_blank');
  }
}
